import React from 'react';
import Translation from '../../../../translation/translation';

function SimpleLabel() {
    return (
        <Translation
            translationKey="catalog-statusbar-mobile-size-label"
            className="statusbar-mobile-current-status__size-label"
            tagName="span"
        />
    );
}

export { SimpleLabel };
